module.exports = __webpack_public_path__ + "img/hands-holding-diamond.0d6e0857.svg";